import React from "react";
import { Eye, EyeOff } from "lucide-react";
import { ShapeControlProps } from "./types";
import { ShapeControlButton } from "./ShapeControlButton";
import { useEditorShortcuts } from "../../../shortcuts/EditorShortcutContext/useEditorShortcuts";

export const ShapeControlHide: React.FC<ShapeControlProps> = ({
  shape,
  onUpdate,
}) => {
  const { shortcuts } = useEditorShortcuts();
  return (
    <ShapeControlButton
      onClick={() => onUpdate({ hidden: !shape.hidden })}
      title={shape.hidden ? "Show" : "Hide"}
      icon={shape.hidden ? Eye : EyeOff}
      shortcut={shortcuts.shapeSelection.showHide}
    />
  );
};
